const propertyToEscape = ['from', 'size', 'orderProperty', 'orderDirection'];
export const adaptListParams = (params) => {
    const toInclude = Object.keys(params).reduce((acc, k) => {
        if (propertyToEscape.indexOf(k) === -1) {
            acc[k] = params[k];
        }
        return acc;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign({}, toInclude), ((params.orderProperty && params.orderDirection) &&
        { order: `${params.orderProperty}:${params.orderDirection}` })), (params.from && { skip: params.from })), (params.size && { take: params.size }));
};
export const getObjectSizeInBytes = (obj) => Buffer
    .from(encodeURIComponent(JSON.stringify(obj)))
    .length;
export const chunkArrByMaxSize = (arr, maxSize) => {
    const size = getObjectSizeInBytes(arr);
    if (size < maxSize) {
        return [arr];
    }
    else if (arr.length === 1) {
        throw new Error('The first Single array element exceeds maximum size');
    }
    const chunks = [];
    let chunkIdx = 0;
    let chunkSize = 0;
    let lastTakenItem = 0;
    for (let idx = 0; idx < arr.length; idx++) {
        const itemSize = getObjectSizeInBytes(arr[idx]);
        if (itemSize > maxSize) {
            throw new Error(`Single array element exceeds maximum size: size of the ${idx} element is ${itemSize} while maximum size is ${maxSize}`);
        }
        if (chunkSize + itemSize < maxSize) {
            chunkSize += itemSize;
        }
        else {
            chunks[chunkIdx] = arr.slice(lastTakenItem, idx);
            chunkIdx += 1;
            chunkSize = itemSize;
            lastTakenItem = idx;
        }
    }
    const chunksLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
    if (chunksLength < arr.length) {
        chunks[chunkIdx + 1] = arr.slice(chunksLength);
    }
    return chunks.filter((c) => !!c);
};
export function debouncePromise(caller, delay) {
    let timeout = null;
    return new Promise((res, rej) => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => caller().then((x) => res(x)).catch((err) => rej(err)), delay);
    });
}
export const mergeObjects = (first, second) => {
    for (const [key, value] of Object.entries(second)) {
        first[key] = value;
    }
    return first;
};
//# sourceMappingURL=utils.js.map